import useViewRouter from '~/hooks/useViewRouter'
import { VIEWS } from '~/types/ViewTypes'
import moment from 'moment'

interface Props {
    position?: 'RIGHT' | 'LEFT'
    showDate?: boolean
    isAbsolute?: boolean
    withBackground?: boolean
}

const LogoHeader = ({ position = 'RIGHT', showDate=false, isAbsolute=false, withBackground=false }: Props) => {
    const viewRouter = useViewRouter()
    const handleLogoClick = () => {
        viewRouter.push(VIEWS.MENU)
    }
    const containerClassName = `colored-logo-header ${position === "RIGHT" ? "colored-logo-header--right" : ""} ${isAbsolute ? "colored-logo-header--absolute" : ""}`
    const imgClassName = `colored-logo-header__logo ${ withBackground ? "colored-logo-header__logo--with-background" : ""}`
    return(
        <div className={containerClassName}>
            <img className={imgClassName} src="/images/logos/logo-color.png" onClick={handleLogoClick} alt="logo"/>
            <Date isVisible={showDate}/>
        </div>
    )
}

const Date = ({ isVisible }: { isVisible: boolean }) => {
    if(!isVisible) return null
    const date = moment().format('ll')
    return <div className="colored-logo-header__date">{date}</div>
}

export default LogoHeader